<template>
  <v-card
    light
  >
    <v-card-title class="third d-flex justify-space-between white--text">
      <span>Participant 10 derniers chevaux</span>
    </v-card-title>

    <div class="full-width pa-4">
      <v-row no-gutters>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          color="third"
          class="pb-4 pt-0 mt-0 mr-4"
        />
      </v-row>
      <v-row no-gutters>
        <v-data-table
          height="580"
          :items="tableItems"
          item-key="id"
          :search="search"
          :loading="loading"
          :hide-default-footer="true"
          :items-per-page="-1"
          :headers="headers"
          :custom-filter="filter"
        >
          <template #progress>
            <v-progress-linear
              indeterminate
              color="third"
            />
          </template>
        </v-data-table>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { ref, computed, onBeforeMount } from '@vue/composition-api';
import { endOfDay, format, fromUnixTime, getUnixTime } from 'date-fns';
import { sortArray } from '@/helpers/utils';
import { getCustomerHorseHistory } from '@/helpers/request';

import store from '@/store';

export default {
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const loading = ref(false);
    const search = ref(null);
    const tableItems = ref([]);

    const horses = computed(() => store.state.horses);
    const selectedDate = computed(() => store.getters.selectedDate);
    const headers = computed(() => [
      { text: 'Session', value: 'sessionName', align: 'center', sortable: false, width: '45%' },
      { text: 'Date', value: 'date', align: 'center', sortable: false, width: '15%' },
      { text: 'Heure de début', value: 'startTime', align: 'center', sortable: false, width: '15%' },
      { text: 'Cheval', value: 'horseName', align: 'center', sortable: false, width: '35%' }
    ]);

    const filter = (_, searchValue, item) => item.sessionName.toLowerCase().includes(searchValue.toLowerCase()) || item.horseName.toLowerCase().includes(searchValue.toLowerCase());

    onBeforeMount(async () => {
      loading.value = true;
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }

      // get customer last sessions
      if (props.customer.uuid) {
        const response = await getCustomerHorseHistory({ customerUuid: props.customer.uuid, date: getUnixTime(endOfDay(new Date(selectedDate.value))), size: 50 });
        if (!response.success || !(response.data && response.data.length)) {
          loading.value = false;
          return;
        }
        const sessions = sortArray(response.data, 'end_time', '>');

        const sessionsWithParticipantAndHorse = sessions.filter(session => (session.participants || []).some(p => p.uuid === props.customer.uuid && p.horse));

        // 10 sessions to show always
        const sessionsToShow = sessionsWithParticipantAndHorse.slice(0, 10);

        sessionsToShow.map(session => {
          const participant = (session.participants || []).find(p => p.uuid === props.customer.uuid);

          const horse = horses.value.find(h => h.uuid === participant.horse);

          if (horse) {
            tableItems.value.push({
              id: `${session.id}_${participant.horse}`,
              sessionName: session.name,
              date: format(fromUnixTime(session.start_time), 'dd-MM-yyyy'),
              startTime: format(fromUnixTime(session.start_time), 'HH:mm'),
              endTime: format(fromUnixTime(session.end_time), 'HH:mm'),
              horse: participant.horse,
              horseName: horse ? horse.horse_name : ''
            });
          }
        });

      }
      loading.value = false;
    });

    return { search, loading, headers, tableItems, filter };
  }
};

</script>
